"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const deep_equal_1 = __importDefault(require("deep-equal"));
const basic_form_input_1 = __importDefault(require("../../../../client/form_components/inputs/basic_form_input"));
const breadcrumb_1 = __importDefault(require("../../../../client/nav_components/breadcrumb"));
const base_1 = __importDefault(require("../../../../client/buttons/base"));
const ChallengeFAQ_1 = __importDefault(require("./ChallengeFAQ"));
const FAQ_1 = __importDefault(require("./FAQ"));
const Input_1 = __importDefault(require("./Input"));
const radio_group_1 = __importDefault(require("../../../../client/form_components/inputs/radio_group"));
const types_1 = require("./types");
const user_helpers_1 = require("../../../../utility/user_helpers");
const constants_1 = require("../../../tiers/constants");
const graphql_1 = require("../../../../requests/graphql");
const main_1 = __importDefault(require("../../../../services/keen/main"));
const eventTypeTemplates_1 = require("../../../../services/keen/events/eventTypeTemplates");
const templates_1 = require("../../../../client/form_components/templates");
const accessors_1 = require("../../../../utility/accessors");
const enums_1 = require("../../../../graphql/challenges/enums");
const dispatchers_1 = require("../../../../utility/dispatchers");
const formatters_1 = require("../../../../utility/forms/formatters");
const forms_1 = require("../../../../utility/forms");
const time_1 = require("../../../../utility/time");
const validators_1 = require("../../../../services/validation/validators");
const window_1 = require("../../../../services/window");
const current_user_1 = __importDefault(require("../../../../services/current_user"));
const error_handler_1 = __importDefault(require("../../../../services/error_handler"));
const forms_css_1 = __importDefault(require("../../../../styles/global_ui/forms.css"));
const inputs_css_1 = __importDefault(require("../../../../styles/global_ui/inputs.css"));
const layout_css_1 = __importDefault(require("../../../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../../../styles/global_ui/typography.css"));
const idea_form_css_1 = __importDefault(require("./idea_form.css"));
/* I agree checkbox configs */
const AGREE_OPTS = [
    { label: 'Yes, I agree', value: 'true' },
    { label: 'No (Cannot submit if no)', value: 'false' },
];
const AGREE_TO_ERROR_MSG = 'You must agree in order to be considered for free hardware';
const AGREE_TO_VALIDATION = (value) => (0, validators_1.agreeTo)(value, formatters_1.boolOrNullOut, AGREE_TO_ERROR_MSG);
const OWNED_OPTS = [
    { label: 'Yes', value: 'yes' },
    { label: 'I have some parts', value: 'some' },
    { label: 'No', value: 'no' },
];
/* Status states */
const SUBMIT_STATUS = 'PENDING_REVIEW';
const EDITING_STATUS = 'DRAFT';
/* Base template for form fields */
const FIELDS_TEMPLATE = (skipDefault) => ({
    build: {
        slug: 'build',
        order: 2,
        notRequired: skipDefault,
        validate: (value) => (0, validators_1.minLength)(1, value),
        value: '',
    },
    components: {
        slug: 'components',
        order: 4,
        notRequired: skipDefault,
        validate: (value) => (0, validators_1.minLength)(1, value),
        value: '',
    },
    hours_weekly: {
        slug: 'hours_weekly',
        order: 6,
        notRequired: skipDefault,
        validate: skipDefault ? () => null : (value) => (0, validators_1.isInt)(value),
        value: '',
        formatOut: formatters_1.numOrNullOut,
    },
    hours_total: {
        slug: 'hours_total',
        order: 7,
        notRequired: skipDefault,
        validate: skipDefault ? () => null : (value) => (0, validators_1.isInt)(value),
        value: '',
        formatOut: formatters_1.numOrNullOut,
    },
    i_agree_submit: {
        order: 10,
        validate: AGREE_TO_VALIDATION,
        value: '',
        formatIn: formatters_1.boolOrNullIn,
        formatOut: formatters_1.boolOrNullOut,
    },
    i_agree_ship_back: {
        order: 11,
        validate: AGREE_TO_VALIDATION,
        value: '',
        formatIn: formatters_1.boolOrNullIn,
        formatOut: formatters_1.boolOrNullOut,
    },
    owned: {
        slug: 'owned',
        order: 5,
        notRequired: skipDefault,
        validate: (value) => (0, validators_1.minLength)(1, value),
        value: '',
        formatIn: formatters_1.lowerCaseIn,
        formatOut: formatters_1.stringOrNullOut,
        customRequired: validators_1.optionIsRequired,
    },
    problem: {
        slug: 'problem',
        order: 1,
        notRequired: skipDefault,
        validate: (value) => (0, validators_1.minLength)(1, value),
        value: '',
    },
    skills: {
        slug: 'skills',
        order: 8,
        notRequired: skipDefault,
        validate: (value) => (0, validators_1.minLength)(1, value),
        value: '',
    },
    solution: {
        slug: 'solution',
        order: 3,
        notRequired: skipDefault,
        validate: (value) => (0, validators_1.minLength)(1, value),
        value: '',
    },
    title: {
        order: 0,
        validate: (value) => (0, validators_1.maxLength)(140, value),
        value: '',
    },
});
const CONTEST_DATE_FULL_MONTH_FORMAT = {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
};
/* Fifteen days in MS */
const HALF_MONTH_MS = 24 * 60 * 60 * 1000 * 15;
const getCustomFieldProps = (q) => {
    if (!(0, enums_1.isInputTypeWithOptions)(q.input_type))
        return {};
    return {
        formatOut: (field) => field,
        options: q.options.map((o) => ({ label: o, value: o })),
        placeholder: q.input_type === 'MULTI' ? 'Select options' : 'Select an option',
    };
};
class ContestIdeaForm extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUserId: null,
            dates: {},
            errors: {},
            formError: null,
            initialized: false,
            isBusy: true,
            lastSaveState: null,
            fields: {},
        };
        this.setStateOrError = null;
        this.getErrorForField = null;
        this.getFieldValuesAsObject = null;
        this.validate = null;
        this._REDIRECT_PATH = null;
        this.mode = 'default';
        this.mode = props.mode || 'default';
        const idea = this._formatIdeaIn(props.idea);
        const fhFields = props.challenge.free_hardware_custom_fields;
        const fhFieldsCustomProps = fhFields.reduce((acc, field) => {
            acc[field.id] = getCustomFieldProps(field);
            return acc;
        }, {});
        const skipDefault = props.challenge.hide_default_hw_questions
            || props.challenge.contest_type === 'challenge';
        const template = FIELDS_TEMPLATE(skipDefault);
        const fields = (0, forms_1.initFieldsWithOptionalFields)(template, idea, fhFields, {
            customProps: fhFieldsCustomProps,
            key: types_1.EXTRA_FIELDS_KEY,
            insertOptsAtIndex: 10,
        });
        const shipBackDateSecs = Math.round((new Date(props.challenge.end_date).valueOf() - HALF_MONTH_MS) / 1000);
        this.state = {
            currentUserId: null,
            userTier: null,
            dates: {
                endDate: (0, time_1.formatContestTimestampPT)(props.challenge.end_date, time_1.CONTEST_DATE_AT_TIME_FORMAT),
                shipBack: (0, time_1.formatContestTimestampPT)(shipBackDateSecs, CONTEST_DATE_FULL_MONTH_FORMAT),
            },
            errors: {},
            formError: null,
            initialized: false,
            isBusy: true,
            lastSaveState: (0, forms_1.getFieldValuesAsObject)(fields),
            fields,
        };
        this.getErrorForField = forms_1.getErrorForField.bind(this);
        this.getFieldValuesAsObject = forms_1.getFieldValuesAsObject.bind(this);
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSaveForLater = this.handleSaveForLater.bind(this);
        this.setStateOrError = forms_1.setStateOrError.bind(this);
        this.validate = forms_1.validateFields.bind(this);
        this._REDIRECT_PATH = `${props.challenge.url}/ideas`;
    }
    componentDidMount() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        this._initialize();
    }
    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }
    /**
     * Initializers
     */
    _formatIdeaIn(idea) {
        if (!idea)
            return null;
        return {
            build: (0, accessors_1.getInObj)(['build'], idea.application),
            components: (0, accessors_1.getInObj)(['components'], idea.application),
            hours_weekly: (0, accessors_1.getInObj)(['hours_weekly'], idea.application),
            hours_total: (0, accessors_1.getInObj)(['hours_total'], idea.application),
            i_agree_submit: (0, accessors_1.getInObj)(['i_agree_submit'], idea.application),
            i_agree_ship_back: (0, accessors_1.getInObj)(['i_agree_ship_back'], idea.application),
            owned: (0, accessors_1.getInObj)(['owned'], idea.application),
            problem: (0, accessors_1.getInObj)(['problem'], idea.application),
            skills: (0, accessors_1.getInObj)(['skills'], idea.application),
            solution: (0, accessors_1.getInObj)(['solution'], idea.application),
            title: (0, accessors_1.getInObj)(['name'], idea),
            ...this._formatExtraFieldsIn(idea.extra_fields),
        };
    }
    _formatExtraFieldsIn(fields) {
        if (!fields || fields.length === 0)
            return {};
        return fields.reduce((acc, field) => {
            acc[`${types_1.EXTRA_FIELDS_KEY}_${field.id}`] = field.answer;
            return acc;
        }, {});
    }
    _initialize() {
        return current_user_1.default
            .getStoreAsync()
            .then((res) => this.setState({
            currentUserId: res.id,
            initialized: true,
            isBusy: false,
            userTier: res.tier,
        }))
            .catch((err) => (0, error_handler_1.default)('ContestIdeaForm _fetchCurrentUser', err));
    }
    /**
     * Methods
     */
    handleBeforeUnload(e) {
        if (this._hasUnsavedChanges()) {
            const msg = 'Changes you made may not be saved.';
            (e || window.event).returnValue = msg;
            return msg;
        }
    }
    handleSubmit(e) {
        const validated = this.validate();
        if (validated) {
            return this._postIdea(SUBMIT_STATUS, e);
        }
    }
    handleSaveForLater(e) {
        return this._postIdea(EDITING_STATUS, e);
    }
    /**
     * Requests
     */
    _postIdea(status, e) {
        const mutation = this.mode === 'default'
            ? { t: 'create_challenge_idea' }
            : { t: 'update_challenge_idea' };
        this.setState({ isBusy: true });
        return (0, graphql_1.graphMutate)(mutation, this._formatIdeaOut(status))
            .then(({ record }) => {
            if (this.mode === 'default') {
                this._recordCreationAndRedirect(record, e);
            }
            else {
                this._removeUnloadListenerAndRedirect();
            }
        })
            .catch((err) => {
            const formError = (0, accessors_1.getInObj)(['response', 'body', 'form_error'], err);
            this.setState({
                isBusy: false,
                formError,
            });
            if (!formError) {
                (0, dispatchers_1.summonGlobalMessenger)({
                    msg: 'Sorry. There was an error saving your application.',
                    type: 'error',
                });
            }
            (0, error_handler_1.default)('ContestIdeaForm _postIdea', err);
        });
    }
    /**
     * Helpers
     */
    _formatIdeaOut(status = EDITING_STATUS) {
        const fields = this.getFieldValuesAsObject();
        const id = this.props.idea && this.props.idea.id ? { id: this.props.idea.id } : {};
        const application = { ...fields };
        const extraFieldsKeys = Object.keys(fields).filter((f) => f.includes(types_1.EXTRA_FIELDS_KEY));
        const extraFields = extraFieldsKeys.reduce((acc, k) => acc.concat({ id: this.state.fields[k].id, answer: fields[k] }), []);
        const extra_fields = extraFields.length > 0 ? { extra_fields: extraFields } : {};
        // Delete all properties that don't belong in the application bucket.
        if (extraFieldsKeys.length > 0) {
            extraFieldsKeys.forEach((k) => {
                delete application[k];
            });
        }
        delete application.title;
        return {
            ...id,
            challenge_id: this.props.challenge.id,
            name: fields.title,
            application,
            status,
            ...extra_fields,
        };
    }
    _hasUnsavedChanges() {
        const currentFields = this.getFieldValuesAsObject();
        const lastSaveState = this.state.lastSaveState;
        return !(0, deep_equal_1.default)(currentFields, lastSaveState);
    }
    _recordCreationAndRedirect(record, e) {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        main_1.default.reportEventWithDelayedRedirectWithObj((0, eventTypeTemplates_1.getCreateContestIdeaArgs)({
            id: this.props.challenge.id,
            idea_id: record.id,
        }), this._REDIRECT_PATH, e);
    }
    // So we don't have to do another deep equals post save or submit.
    _removeUnloadListenerAndRedirect() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        (0, window_1.windowLocationRedirect)(this._REDIRECT_PATH);
    }
    /**
     * Views
     */
    _getCustomFieldsViews() {
        const customFields = this.props.challenge.free_hardware_custom_fields;
        if (!customFields || (customFields && !customFields.length))
            return;
        return customFields.map((f) => {
            const key = `${types_1.EXTRA_FIELDS_KEY}_${f.id}`;
            const field = this.state.fields[key];
            return (react_1.default.createElement("div", { key: key, id: `vf${key}` },
                react_1.default.createElement(Input_1.default, { errors: this.getErrorForField(key), field: field, onChange: (value) => this.setStateOrError(null, key, value), value: field?.value })));
        });
    }
    _getTitleForMode() {
        return this.mode === 'default'
            ? this._getDefaultTitle()
            : this._getEditTitle();
    }
    _getDefaultTitle() {
        const isChallenge = this.props.challenge.contest_type === 'challenge';
        return (react_1.default.createElement("div", { className: layout_css_1.default.marginBottom60 },
            react_1.default.createElement("h2", { className: `${typography_css_1.default.h2} ${layout_css_1.default.marginBottom15}` }, isChallenge
                ? 'Tell us about your proposed solution'
                : 'Tell us about what you’re planning to build and your level of commitment'),
            react_1.default.createElement("p", { className: `${typography_css_1.default.bodyL} ${layout_css_1.default.marginBottom15}` }, isChallenge
                ? 'Competing in a challenge is for people who are committed to building meaningful projects. Only those whose proposals are selected will be able to compete in this challenge.'
                : 'Because we have a limited supply of hardware, we want to make sure we send them to people who are committed to building meaningful projects.'),
            react_1.default.createElement("p", { className: typography_css_1.default.bodyL },
                react_1.default.createElement("strong", null, isChallenge
                    ? 'Please only submit a proposal if you are serious about competing in this challenge.'
                    : 'Please only apply for free hardware if you plan on building and submitting a project.'),
                ' ',
                react_1.default.createElement("span", null, isChallenge
                    ? 'If selected, you will be entering a contract to complete your project.'
                    : 'Participants who receive free hardware and do not submit a project will be flagged by our team and possibly ineligible for future giveaways (up to our discretion).')),
            !(0, user_helpers_1.isPendingOrVerified)(this.state.userTier) && (react_1.default.createElement("div", { className: `${layout_css_1.default.marginTop15} ${layout_css_1.default.marginBottom15} ${typography_css_1.default.bold}` },
                "You will need to get verified to be considered eligible.",
                ' ',
                react_1.default.createElement("a", { href: constants_1.VERIFICATION_LINK, rel: "noopener noreferrer", target: "_blank" }, "Learn more.")))));
    }
    _getEditTitle() {
        return (react_1.default.createElement("div", { className: layout_css_1.default.marginBottom60 },
            react_1.default.createElement("h2", { className: typography_css_1.default.h2 }, "Edit your idea")));
    }
    _getActionButtons() {
        if (!this.props.idea)
            return this._getSubAndSaveButtons();
        return this.props.idea.status === EDITING_STATUS
            ? this._getSubAndSaveButtons()
            : this._getSaveChangesButton();
    }
    _getSaveChangesButton() {
        return (react_1.default.createElement(base_1.default, { disabled: this.state.isBusy, onClick: this.handleSubmit, size: "lg" }, "Save changes"));
    }
    _getSubAndSaveButtons() {
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(base_1.default, { disabled: this.state.isBusy, onClick: this.handleSubmit, size: "lg" }, "Submit idea"),
            react_1.default.createElement(base_1.default, { colorStyle: "cancel", disabled: this.state.isBusy, onClick: this.handleSaveForLater, size: "lg" }, "Save for later")));
    }
    render() {
        const skipDefaultQuestions = this.props.challenge.hide_default_hw_questions || this.props.challenge.contest_type === 'challenge';
        return (react_1.default.createElement("div", { className: layout_css_1.default.container },
            react_1.default.createElement("div", { className: layout_css_1.default.wrapper1170 },
                react_1.default.createElement(breadcrumb_1.default, { classList: { root: layout_css_1.default.marginBottom60, link: typography_css_1.default.bodyS }, href: this._REDIRECT_PATH, text: `Back to ${this.props.challenge.name}` }),
                react_1.default.createElement("div", { className: idea_form_css_1.default.contentWrapper },
                    react_1.default.createElement("div", { className: `${layout_css_1.default.wrapper960}` },
                        this._getTitleForMode(),
                        react_1.default.createElement("div", { className: idea_form_css_1.default.formWrapper },
                            react_1.default.createElement("form", { className: forms_css_1.default.container },
                                react_1.default.createElement("div", { id: "vftitle" },
                                    react_1.default.createElement(basic_form_input_1.default, { charCount: this.state.fields.title.value.length, errors: this.state.errors.title, label: "Title of your idea", maxVal: 140, onChange: (e) => this.setStateOrError((0, validators_1.maxLength)(140, e.target.value), 'title', e.target.value), value: this.state.fields.title.value })),
                                !skipDefaultQuestions && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("div", { id: "vfproblem" },
                                        react_1.default.createElement(basic_form_input_1.default, { element: "textarea", errors: this.state.errors.problem, label: "What problem are you going to solve?", onChange: (e) => this.setStateOrError(null, 'problem', e.target.value), value: this.state.fields.problem.value })),
                                    react_1.default.createElement("div", { id: "vfbuild" },
                                        react_1.default.createElement(basic_form_input_1.default, { element: "textarea", errors: this.state.errors.build, label: "What are you going to build to solve this problem? How is it different from existing solutions? Why is it useful?", onChange: (e) => this.setStateOrError(null, 'build', e.target.value), value: this.state.fields.build.value })),
                                    react_1.default.createElement("div", { id: "vfsolution" },
                                        react_1.default.createElement(basic_form_input_1.default, { element: "textarea", errors: this.state.errors.solution, label: `How does your solution work? What are the main features? Please specify how you will use the ${this.props.challenge.free_hardware_name} in your solution.`, onChange: (e) => this.setStateOrError(null, 'solution', e.target.value), value: this.state.fields.solution.value })),
                                    react_1.default.createElement("div", { id: "vfcomponents" },
                                        react_1.default.createElement(basic_form_input_1.default, { element: "textarea", errors: this.state.errors.components, label: "List the hardware and software you will use to build this (in addition to the required hardware and/or software).", onChange: (e) => this.setStateOrError(null, 'components', e.target.value), value: this.state.fields.components.value })),
                                    react_1.default.createElement("div", { id: "vfowned" },
                                        react_1.default.createElement(radio_group_1.default, { buttons: OWNED_OPTS, errors: this.state.errors.owned, label: `Except for the ${this.props.challenge.free_hardware_name}, do you already have the parts you need to build this project?`, name: "owned", onChange: (e) => this.setStateOrError(null, 'owned', e.target.value), value: this.state.fields.owned.value })),
                                    react_1.default.createElement("div", { id: "vfhours_weekly" },
                                        react_1.default.createElement(basic_form_input_1.default, { errors: this.state.errors.hours_weekly, label: "How many hours will you be able to spend on this project per week?", onChange: (e) => this.setStateOrError(null, 'hours_weekly', e.target.value), type: "number", value: this.state.fields.hours_weekly.value })),
                                    react_1.default.createElement("div", { id: "vfhours_total" },
                                        react_1.default.createElement(basic_form_input_1.default, { errors: this.state.errors.hours_total, label: "How many total hours do you estimate this will take you to build?", onChange: (e) => this.setStateOrError(null, 'hours_total', e.target.value), type: "number", value: this.state.fields.hours_total.value })),
                                    react_1.default.createElement("div", { id: "vfskills" },
                                        react_1.default.createElement(basic_form_input_1.default, { element: "textarea", errors: this.state.errors.skills, label: "Tell us about yourself. What do you spend most of your time doing? What skills or experience do you have that will enable you to be successful in building this project?", onChange: (e) => this.setStateOrError(null, 'skills', e.target.value), value: this.state.fields.skills.value })))),
                                this._getCustomFieldsViews(),
                                react_1.default.createElement("div", { id: "vfi_agree_submit" },
                                    react_1.default.createElement(radio_group_1.default, { buttons: AGREE_OPTS, errors: this.state.errors.i_agree_submit, label: `I agree that if I am selected, I will submit a project to the ${this.props.challenge.name} contest by ${this.state.dates.endDate}.`, name: "i_agree_submit", onChange: (e) => this.setStateOrError((0, validators_1.agreeTo)(e.target.value, formatters_1.boolOrNullOut, AGREE_TO_ERROR_MSG), 'i_agree_submit', e.target.value), value: this.state.fields.i_agree_submit?.value })),
                                react_1.default.createElement("div", { id: "vfi_agree_ship_back" },
                                    react_1.default.createElement("label", { className: inputs_css_1.default.label },
                                        react_1.default.createElement("span", null,
                                            "If I am not able to submit for any reason, I will contact the contest admins at",
                                            ' '),
                                        react_1.default.createElement("a", { href: `mailto:${this.props.challenge.support_email}`, rel: "noopener nofollow noreferrer", target: "_blank" }, this.props.challenge.support_email),
                                        react_1.default.createElement("span", null, ` by ${this.state.dates.shipBack} in order to arrange a possible hardware return.`)),
                                    react_1.default.createElement(radio_group_1.default, { buttons: AGREE_OPTS, errors: this.state.errors.i_agree_ship_back, name: "i_agree_ship_back", onChange: (e) => this.setStateOrError((0, validators_1.agreeTo)(e.target.value, formatters_1.boolOrNullOut, AGREE_TO_ERROR_MSG), 'i_agree_ship_back', e.target.value), value: this.state.fields.i_agree_ship_back?.value })),
                                react_1.default.createElement("div", { className: layout_css_1.default.marginTop60 },
                                    this._getActionButtons(),
                                    this.state.formError
                                        && (0, templates_1.getFormErrorView)(this.state.formError))),
                            this.props.challenge.contest_type === 'challenge'
                                ? (react_1.default.createElement(ChallengeFAQ_1.default, { hardware: {
                                        remaining: this.props.challenge.free_hardware_quantity_remaining,
                                    } }))
                                : (react_1.default.createElement(FAQ_1.default, { hardware: {
                                        name: this.props.challenge.free_hardware_name,
                                        remaining: this.props.challenge.free_hardware_quantity_remaining,
                                    }, supportEmail: this.props.challenge.support_email }))))))));
    }
}
exports.default = ContestIdeaForm;
